var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientWidget(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#E4F3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.993 11.193C13.6341 11.193 14.9645 9.86261 14.9645 8.2215C14.9645 6.58039 13.6341 5.25 11.993 5.25C10.3519 5.25 9.02148 6.58039 9.02148 8.2215C9.02148 9.86261 10.3519 11.193 11.993 11.193Z",
    fill: "#438BFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9933 12.1084C10.6027 12.1084 9.26901 12.6608 8.28571 13.6441C7.30241 14.6274 6.75 15.9611 6.75 17.3516C6.75 17.7224 6.89729 18.078 7.15946 18.3402C7.42164 18.6024 7.77723 18.7497 8.148 18.7497H15.8385C16.2093 18.7497 16.5649 18.6024 16.827 18.3402C17.0892 18.078 17.2365 17.7224 17.2365 17.3516C17.2365 15.9611 16.6841 14.6274 15.7008 13.6441C14.7175 12.6608 13.3838 12.1084 11.9933 12.1084Z",
    fill: "#438BFE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientWidget);
export default __webpack_public_path__ + "static/media/clientWidget.00e9c64a148663772c76a4c9508f7f34.svg";
export { ForwardRef as ReactComponent };